import { render, staticRenderFns } from "./AllergenInfo.vue?vue&type=template&id=42952d11&scoped=true&"
import script from "./AllergenInfo.vue?vue&type=script&lang=js&"
export * from "./AllergenInfo.vue?vue&type=script&lang=js&"
import style0 from "./AllergenInfo.vue?vue&type=style&index=0&id=42952d11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42952d11",
  null
  
)

export default component.exports